import React from 'react';
import { stopSalesTableColumns } from '../../../../utils/stopSales/stopSalesUtils';
import TableStructure from '../../../components/listView/TableStructure';
import { useStopSalesList } from '../../../contextsProperty/ContextStopSales';
import StopSalesRow from './StopSalesRow';

const StopSalesTable = () => {
    const { items, isLoading, sortDir, sortedBy, sortByField, handleScroll } =
        useStopSalesList();

    return (
        <TableStructure
            onScroll={handleScroll}
            columns={stopSalesTableColumns}
            sortedBy={sortedBy}
            sortDir={sortDir}
            sortByField={sortByField}
            isLoading={isLoading}
            items={items}
            rowComponent={props => <StopSalesRow stopSale={props.item} />}
        />
    );
};

export default StopSalesTable;
